import { classNames } from 'libs/react';
import { DropdownMenuItem } from 'components/DropdownMenuItem';
import { React } from 'libs/react';
import './DropdownMenu.scss';
/**
 * @component DropdownMenu
 * @since 1.0.0
 * @hidden
 */
export function DropdownMenu(props) {
    const { style, items, value, openUpward, maxHeight } = Object.assign({ style: 'normal' }, props);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick(value) {
        if (props.onSelect) {
            props.onSelect(value);
        }
    }
    /**
     * @function onMouseEnter
     * @since 1.0.0
     * @hidden
     */
    function onMouseEnter(value) {
        if (props.onMouseEnter) {
            props.onMouseEnter(value);
        }
    }
    /**
     * @function onMouseLeave
     * @since 1.0.0
     * @hidden
     */
    function onMouseLeave(value) {
        if (props.onMouseLeave) {
            props.onMouseLeave(value);
        }
    }
    const className = classNames('dropdown-menu', 'dropdown-menu--' + style, { 'dropdown-menu--open-upward': openUpward }, props.className);
    const inlineStyle = maxHeight ? { maxHeight: `${maxHeight}px`, overflowY: 'auto' } : undefined;
    return (React.createElement("div", { className: className, style: inlineStyle }, items.map((item) => (React.createElement(DropdownMenuItem, { key: item.value, current: item.value === value, style: item.style, picto: item.picto, image: item.image, label: item.label, infos: item.infos, value: item.value, color: item.color, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick })))));
}
